<template>
  <section class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row gutter="20" style="row-gap: 5px;">
            <el-col  :md="14">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div
                    class="form-element input-with-icon search-input-lg w-200"
                  >
                    <el-input
                      placeholder="Accession / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :md="10">
              <ul class="d-flex justify-content-end list-items-group-15 w-90">
                <li>
                  <el-button
                    class="btn button-with-icon"
                    @click="onReportsExport"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/export-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>Export</span>
                  </el-button>
                </li>
                <li>
                  <div
                    class="form-element search-with-filter-input-without-icon"
                  >
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Select Search"
                      @change="clearInputSearch"
                      @focus="initializeSearchOptions"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </li>
                <li v-if="searchBy == 'Patient DOB'">
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchAllCases()"
                      placeholder="Select DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li v-else-if="searchBy == 'hospital'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="selectedHospital"
                      placeholder="Select Ordering Facility"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      value-key="_id"
                      @change="onHospitalChange"
                      @focus="onHospitalFocus"
                      remote
                      :remote-method="remoteMethodFacility"
                      :loading="hospitalLoading"
                    >
                      <el-option
                        v-for="hospital in hospitalsData.data"
                        :key="hospital"
                        :label="hospital.name"
                        :value="hospital"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'ordering_physician'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="physician"
                      placeholder="Select"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      :loading="physicianLoading"
                      remote
                      :remote-method="remoteMethodPhysician"
                    >
                      <el-option
                        v-for="physician in physiciansData.data"
                        :key="physician"
                        :label="physician.first_name + '' + physician.last_name"
                        :value="physician._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllCases.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
            @selection-change="handleSelectionChange($event)"
          >
            <el-table-column
              type="selection"
              width="40"
              class="selection-check"
            ></el-table-column>
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="180"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession" style="display: flex">
                  <span
                    id="accession-id"
                    @click="goToCaseView(scope.row._id)"
                    style="margin-right: 2px"
                  >
                    {{ scope.row.accession_id }}
                    <span
                      :style="
                        scope.row.Priority === 'STAT'
                          ? 'color: red; font-weight: 600;'
                          : ''
                      "
                    >
                      {{
                        scope.row.Priority === "STAT"
                          ? "- " + scope.row.Priority
                          : ""
                      }}
                    </span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              prop="case_types"
              min-width="135px"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div
                  v-else-if="
                    scope.row.case_types && scope.row.case_types.length == 1
                  "
                  class="case-type"
                >
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              min-width="140"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  "
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" min-width="100">
              <template #default="scope">
                <span style="cursor: default" v-if="scope.row.patient_info">
                  {{
                    scope.row.patient_info.date_of_birth
                      ? formatDate(scope.row.patient_info.date_of_birth)
                      : ""
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="ordering_facility"
              label="ORDERING FACILITIES"
              min-width="215"
              class="ordering_facility"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="text-center ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Physician" min-width="120">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.first_name + ' ' + scope.row.ordering_physician.last_name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      scope.row.ordering_physician
                        ? scope.row.ordering_physician.first_name + " " + scope.row.ordering_physician.last_name
                        : "--"
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Collected On"
              min-width="135"
              prop="collection_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.collection_date" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.collection_date,
                        "MM-DD-yyyy",
                        scope.row.timezone
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Received On"
              min-width="125"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.received_date, "MM-DD-yyyy", scope.row.timezone)
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Status"
              width="130"
              sortable="custom"
              prop="status"
            >
              <template v-slot="scope">
                <div class="column-status cursor" v-if="scope.row.status">
                    <span class="el-dropdown-link">
                      <el-tag :type="getStatusType(scope.row.status)">
                        {{
                          scope.row.status === "COMPLETE"
                            ? "FINALIZED"
                            : scope.row.status === "TEST_REPORTS"
                            ? "PROCESSING"
                            : scope.row.status.split("_").join(" ")
                        }}
                      </el-tag>
                    </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Reported On"
              min-width="125"
              prop="reported_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.finalized_date && scope.row.status==='COMPLETE'" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.finalized_date, "MM-DD-yyyy", scope.row.timezone)
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ARCHIVE REASON"
              width="300"
              v-if="
                hasPermission('cases', 'attachments') &&
                this.$route.path === '/all-cases/archive'
              "
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span id="accession-id-blue">
                    {{
                      scope.row.archive_reason ? scope.row.archive_reason : "--"
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Testgo Order" width="180">
              <template #default="scope">
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.order_id"
                >
                  <span
                    id="accession-id-blue"
                    @click="sendParameter(scope.row)"
                  >
                    {{ scope.row.testgo_order_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="REJECTED REASONS"
              width="300"
              v-if="$route.path === '/all-cases/rejected'"
            >
              <template #default="{ row }">
                <div class="name-accession cursor">
                  <el-tooltip
                    v-if="row.reasons && row.reasons.length > 0"
                    effect="dark"
                    placement="top"
                  >
                    <template #content>
                      {{ row.reasons.join(", ") }}
                    </template>
                    <span id="accession-id-blue" class="truncate-text">
                      {{ row.reasons.join(", ") }}
                    </span>
                  </el-tooltip>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Results"
              width="180"
            >
              <template #default="scope">
                <div
                  class="column-status"
                  v-if="scope.row.status == 'COMPLETE'"
                >
                  <div class="date pr-10">
                    <el-tag :type="getCovidStatusType(scope.row.report_result_status)">
                      {{ scope.row.report_result_status }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              :width="isSuperAdmin ? '230' : '220'"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToCaseView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="scope.row.status == 'COMPLETE'"
                  >
                    <el-button
                      title="View Report"
                      class="reports-button"
                      @click="onViewReports(scope.row)"
                    >
                      <span
                        class="beforeTestReportsIcon"
                      >
                        <img
                          src="@/assets/images/icons/actions/beforeViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllCases.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <ExportCases
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
      :selected_dob="date_of_birth"
      :selected_hospital="hospital ? [hospital] : []"
      :selected_physician="physician"
      :selected_string="search_string"
      :search_case_status="selectedStatuses"
      :search_billed_status="selectedBilledStatuses"
      :search_billed_sub_status="selectedSubStatuses"
    >
    </ExportCases>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import {
  casesExtraSearchOptions,
} from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import AppHelper from "@/mixins/AppHelper";
import config from "@/config/app";
const ExportCases = defineAsyncComponent(() =>
  import("@/components/cases/ExportCases")
);
export default {
  name: "allCases",
  components: {
    ExportCases,
  },
  props: {
    selectedStatuses: {
      default: [],
    },
    selectedReportStatus: {
      default: false,
    },
    selectedBilledStatuses: {
      default: "",
    },
    selectedSubStatuses: {
      default: "",
    },
    validationStatus: {
      default: false,
    },
  },
  created() {
    this.searchOptions = this.searchOptions.filter((option) => option.active);
  },
  computed: {
    ...mapGetters("auth", [
      "getUserPrimaryLabId",
    ]),
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "CONSISTENT") {
          return "success";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else {
          return "nullvalue";
        }
      };
    },
    ...mapGetters("cases", ["getAllCases"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  mixins: [FilterHelper, UserPermissionsHelper, AppHelper, caseDataHelper],
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      scrollPosition: null,
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      search_string: "",
      debounceTimer: null,
      date_of_birth: "",
      hospital: "",
      selectedHospital: null,
      physician: "",
      searchBy: "",
      loading: false,
      orderBy: "",
      orderType: "",
      caseType: "",
      exportReportsDialogVisisble: false,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      searchOptions: casesExtraSearchOptions,
      selectedCaseIds: [],
      hospitalsData: { data: [] },
      physiciansData: {},
      hospitalLoading: false,
      physicianLoading: false,
    };
  },

  async mounted() {
    const versionHandled = localStorage.getItem("versionHandled");
    if (!versionHandled) {
      this.handleVersioning();
      // Set the flag in local storage to indicate that handleVersioning has been called
      localStorage.setItem("versionHandled", "true");
    }
    await this.initData();
    // Add Class to body on scroll
    window.addEventListener("Noscroll", this.onScroll);
  },
  beforeUnmount() {
    localStorage.removeItem("searchQueryFacility");
    localStorage.removeItem("searchQueryPhysician");
  },
  methods: {
    onHospitalChange(value) {
      this.hospital = value && value._id ? value._id : "";
      this.handleCurrentChange(1);
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryFacility", query);
        await this.fetchAllHospitals(query);
      } else {
        // When no query, do not show stale options
        this.hospitalsData.data = [];
      }
    },
    onHospitalFocus() {
      // Prevent dropdown from showing previous selected item before typing
      if (!this.search_string) {
        this.hospitalsData.data = [];
      }
    },
    handleVersioning() {
      const currentVersion = config.APP_VERSION;
      const currentAppName = config.APP_NAME;
      const versionKey = "APP_VERSION";
      const appName = "APP_NAME";
      if (localStorage.getItem(versionKey) !== currentVersion) {
        localStorage.clear();
        localStorage.setItem(versionKey, currentVersion);
        localStorage.setItem(appName, currentAppName);
        window.location.reload(true);
      }
    },
    initializeSearchOptions() {
      this.searchOptions = [...this.searchOptions];
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryPhysician", query);
        await this.fetchAllPhysicians(query);
      }
    },
    sendParameter(row) {
      if (row.order_id) {
        this.goToOrderView(row.order_id);
      }
    },
    goToOrderView(order_id) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: order_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType ||
        this.search_string
      ) {
        this.hospital = "";
        this.selectedHospital = null;
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.search_string = "";
        // Remove persisted search when inputs are explicitly cleared
        try {
          localStorage.removeItem("allCases_search_string");
        } catch (e) {
          // ignore
        }
        this.fetchAllCases(1);
      }
    },
    async initData() {
      this.setQueryParamsData();
      await Promise.all([this.fetchAllCases()]);
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      } else {
        try {
          const persisted = localStorage.getItem("allCases_search_string");
          if (persisted) {
            this.search_string = persisted;
          }
        } catch (e) {
          // ignore
        }
      }
      if (this.$route.query.selectedCaseOrderBy) {
        this.orderBy = this.$route.query.selectedCaseOrderBy;
      }
      if (this.$route.query.selectedCaseOrderType) {
        this.orderType = this.$route.query.selectedCaseOrderType;
      }
      if (this.$route.query.selectedPhysician) {
        const savedQuery = localStorage.getItem("searchQueryPhysician");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllPhysicians(savedQuery);
        }
        this.physician = this.$route.query.selectedPhysician;
      }
      if (this.$route.query.selectedHospital) {
        const savedQuery = localStorage.getItem("searchQueryFacility");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllHospitals(savedQuery);
        }
        this.hospital = this.$route.query.selectedHospital;
        // Try to restore selected hospital object so the select shows name, not id
        const restoredName = this.$route.query.selectedHospitalName || "";
        if (this.hospitalsData && Array.isArray(this.hospitalsData.data)) {
          const found = this.hospitalsData.data.find(
            (h) => h._id === this.hospital
          );
          this.selectedHospital = found || (this.hospital ? { _id: this.hospital, name: restoredName } : null);
          // Ensure options include the selected entry so Element can render the label immediately
          if (!found && this.selectedHospital) {
            this.hospitalsData.data = [...this.hospitalsData.data, this.selectedHospital];
          }
        } else {
          this.selectedHospital = this.hospital ? { _id: this.hospital, name: restoredName } : null;
        }
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      this.searchBy = this.$route.query.selectedSearchBy;
    },
    async fetchAllPhysicians(physician) {
      this.physicianLoading = true;
      let params = {
        limit: 25,
      };
      if (physician) {
        params.search_string = physician;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physicianLoading = false;
    },
    async fetchAllHospitals(hospital) {
      this.hospitalLoading = true;
      let params = {
        limit: 25,
      };
      if (hospital) {
        params.search_string = hospital;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", params);
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalLoading = false;
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.sort_by = this.orderBy;
        params.sort_order = this.orderType;
      }
      if (this.selectedStatuses && this.selectedStatuses.length) {
        params.status = this.selectedStatuses[0];
      }
      if (this.selectedBilledStatuses && this.selectedBilledStatuses.length) {
        params.billing_status = this.selectedBilledStatuses;
      }
      if (this.selectedSubStatuses) {
        params.billing_sub_status = this.selectedSubStatuses;
      }
      params.is_validation_purpose = !!this.validationStatus;
      return params;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllCases();
    },
    getAutoCompleteCases() {
      // persist current search term so it survives tabs reloads
      try {
        localStorage.setItem("allCases_search_string", this.search_string || "");
      } catch (e) {
        // ignore
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.page = 1;
        this.fetchAllCases();
        this.debounceTimer = null;
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllCases();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchAllCases();
    },
    async onReportsExport() {
      this.exportReportsDialogVisisble = true;
    },
    async fetchAllCases() {
      try {
        let params = this.prepareParams();
        if (this.getUserPrimaryLabId) {
          params.lab = this.getUserPrimaryLabId;
        }
        this.loading = true;
        await this.$store.dispatch("cases/fetchAllCases", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    handleSelectionChange(rows) {
      if (rows) {
        this.selectedCaseIds = [];
        for (let caseData of rows) {
          this.selectedCaseIds.push(caseData._id);
        }
      } else {
        this.selectedCaseIds = [];
      }
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: {
          ...this.$route.query,
          redirectRoute: this.$route.name,
          status: this.selectedStatuses,
        },
      });
    },
    async onViewReports(report) {
      let markForPhysician = report?.test_reports.find(
        (e) => e.mark_for_physician
      );
      if (!markForPhysician) {
        console.warn("No physician report found");
        return;
      }
      let routerData = this.$router.resolve({
        name: "supplementaryReportView",
        params: {
          report_id: markForPhysician._id,
          case_id: report._id,
        },
      });
      await this.initData();
      window.open(routerData.href, "_blank");
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.hospital,
        selectedHospitalName:
          (this.selectedHospital && this.selectedHospital.name) ||
          (this.hospitalsData && this.hospitalsData.data
            ? (this.hospitalsData.data.find((h) => h._id === params.hospital) || {}).name
            : undefined),
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedSearchBy: this.searchBy || undefined,
        selectedCaseOrderBy:params.sort_by,
        selectedCaseOrderType:params.sort_order,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
  },
};
</script>
<style lang="scss">
</style>
